(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-section"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ved-editorial-moments-gallery')) {
    customElements.define(
      'ved-editorial-moments-gallery',
      class extends HTMLElement {
        connectedCallback() {
          this.initFrame = requestAnimationFrame(() => this.init());
        }

        init() {
          this.cards = Array.from(this.querySelectorAll('[data-gallery-card]'));
          this.count = this.cards.length;

          if (!this.count) return;

          this.abort = new AbortController();
          this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.mobileQuery = window.matchMedia('(max-width: 767px)');
          this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
          this.hovered = false;
          this.focused = false;
          this.editorSelected = false;
          this.visible = true;
          this.offset = 0;
          this.busy = false;
          this.visibleSlots = Math.min(this.count, 8);
          this.duration = parseFloat(
            getComputedStyle(this).getPropertyValue('--ved-gallery-duration')
          ) || 1100;
          this.interval = Math.max(Number(this.dataset.interval) || 500, 500);
          this.toggle = this.querySelector('[data-gallery-toggle]');
          this.stage = this.querySelector('.ved-gallery__stage');
          this.slotMaps = {
            1: [3],
            2: [3, 4],
            3: [2, 3, 4],
            4: [2, 3, 4, 5],
            5: [1, 2, 3, 4, 5],
            6: [1, 2, 3, 4, 5, 6],
            7: [0, 1, 2, 3, 4, 5, 6],
            8: [0, 1, 2, 3, 4, 5, 6, 7]
          };
          this.slots = this.slotMaps[this.visibleSlots];

          this.updateLayout();

          if (this.count === 1) {
            this.cards[0].style.setProperty('--gallery-x', '50%');
          }

          const controls = this.querySelector('.ved-gallery__controls');
          if (controls) controls.hidden = this.count < 2;

          const on = (target, type, callback) => {
            if (!target) return;
            target.addEventListener(type, callback, { signal: this.abort.signal });
          };

          on(this.mobileQuery, 'change', () => this.updateLayout());

          on(this.querySelector('[data-gallery-next]'), 'click', () => {
            this.move(1, true);
          });

          on(this.querySelector('[data-gallery-previous]'), 'click', () => {
            this.move(-1, true);
          });

          on(this.toggle, 'click', () => {
            this.paused = !this.paused;

            if (!this.paused) {
              this.focused = false;
              this.hovered = false;
            }

            this.updateToggle();
            this.schedule();
          });

          on(this, 'keydown', (event) => {
            if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;

            event.preventDefault();
            this.move(event.key === 'ArrowRight' ? 1 : -1, true);
          });

          on(this, 'pointerenter', (event) => {
            if (
              event.pointerType !== 'mouse' ||
              this.dataset.hoverPause !== 'true'
            ) return;

            this.hovered = true;
            this.schedule();
          });

          on(this, 'pointerleave', () => {
            this.hovered = false;
            this.schedule();
          });

          on(this, 'focusin', () => {
            this.focused = true;
            this.schedule();
          });

          on(this, 'focusout', (event) => {
            this.focused = this.contains(event.relatedTarget);
            this.schedule();
          });

          on(this.stage, 'pointerdown', (event) => {
            if (!event.isPrimary) return;

            this.touchStart = {
              x: event.clientX,
              y: event.clientY
            };
          });

          on(this.stage, 'pointerup', (event) => {
            if (!this.touchStart) return;

            const differenceX = event.clientX - this.touchStart.x;
            const differenceY = event.clientY - this.touchStart.y;
            this.touchStart = null;

            if (
              Math.abs(differenceX) > 30 &&
              Math.abs(differenceX) > Math.abs(differenceY) * 1.4
            ) {
              this.move(differenceX < 0 ? 1 : -1, true);
            }
          });

          on(this.stage, 'pointercancel', () => {
            this.touchStart = null;
          });

          on(this.stage, 'pointerleave', () => {
            this.touchStart = null;
          });

          on(document, 'visibilitychange', () => this.schedule());

          on(this.motion, 'change', () => {
            if (this.motion.matches) this.paused = true;

            this.updateToggle();
            this.schedule();
          });

          const sectionElement = this.closest('.shopify-section') || this;

          on(sectionElement, 'shopify:section:select', () => {
            this.editorSelected = true;
            this.schedule();
          });

          on(sectionElement, 'shopify:section:deselect', () => {
            this.editorSelected = false;
            this.schedule();
          });

          on(this, 'shopify:block:select', (event) => {
            const index = this.cards.findIndex(
              (card) => card.dataset.blockId === event.detail.blockId
            );

            if (index < 0) return;

            this.editorSelected = true;
            clearTimeout(this.animationTimer);
            this.busy = false;
            this.cards.forEach((card) => card.classList.remove('is-wrapping'));

            const centrePosition = this.slots.indexOf(3);
            this.offset = (
              index - centrePosition + this.count
            ) % this.count;

            this.render();
            this.schedule();
          });

          on(this, 'shopify:block:deselect', () => {
            this.editorSelected = false;
            this.schedule();
          });

          if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver((entries) => {
              this.visible = entries[0].isIntersecting;
              this.schedule();
            });
            this.observer.observe(this);
          }

          this.updateToggle();
          this.schedule();
        }

        updateLayout() {
          // Keep the same featured photo when the device changes orientation.
          const featuredIndex = (
            this.offset + this.slots.indexOf(3)
          ) % this.count;

          clearTimeout(this.timer);
          clearTimeout(this.animationTimer);
          this.busy = false;
          this.cards.forEach((card) => card.classList.remove('is-wrapping'));
          this.visibleSlots = Math.min(this.count, this.mobileQuery.matches ? 3 : 8);
          this.slots = this.slotMaps[this.visibleSlots];
          this.offset = (
            featuredIndex - this.slots.indexOf(3) + this.count
          ) % this.count;
          this.dataset.galleryLayout = this.mobileQuery.matches ? 'mobile' : 'desktop';

          this.render();
          this.schedule();
        }

        render() {
          this.cards.forEach((card, index) => {
            const position = (
              index - this.offset + this.count
            ) % this.count;

            const isVisible = position < this.visibleSlots;
            card.dataset.slot = isVisible ? String(this.slots[position]) : '-1';
            card.setAttribute('aria-hidden', String(!isVisible));
          });

          const counter = this.querySelector('[data-gallery-position]');
          if (counter) {
            const featuredIndex = this.cards.findIndex((card) => card.dataset.slot === '3');
            counter.textContent = String(featuredIndex + 1).padStart(2, '0')
              + ' / ' + String(this.count).padStart(2, '0');
          }
        }

        move(direction, announce = false) {
          if (this.busy || this.count < 2) return;

          clearTimeout(this.timer);
          this.busy = true;

          const oldOffset = this.offset;
          const exitingIndex = direction > 0
            ? oldOffset
            : (oldOffset + this.visibleSlots - 1) % this.count;
          const exitingCard = this.cards[exitingIndex];

          if (!this.motion.matches) {
            exitingCard.classList.add('is-wrapping');
          }

          this.offset = (
            this.offset + direction + this.count
          ) % this.count;
          this.render();

          if (announce) {
            const centreSlots = this.mobileQuery.matches ? ['3'] : ['3', '4'];
            const centralCards = this.cards.filter((card) => {
              return centreSlots.includes(card.dataset.slot);
            });

            const centralNames = centralCards.map((card) => {
              const image = card.querySelector('img');
              return image ? image.alt : card.getAttribute('aria-label');
            });

            const status = this.querySelector('[data-gallery-status]');
            if (status) {
              status.textContent = (centralCards.length === 1 ? 'Centre image: ' : 'Centre images: ')
                + centralNames.join(', ');
            }
          }

          this.animationTimer = setTimeout(() => {
            exitingCard.classList.remove('is-wrapping');
            this.busy = false;
            this.schedule();
          }, this.motion.matches ? 0 : this.duration);
        }

        updateToggle() {
          if (!this.toggle) return;

          this.toggle.setAttribute('aria-pressed', String(this.paused));
          this.toggle.setAttribute(
            'aria-label',
            this.paused ? 'Start image rotation' : 'Pause image rotation'
          );
        }

        schedule() {
          clearTimeout(this.timer);

          if (
            this.count < 2 ||
            this.paused ||
            this.hovered ||
            this.focused ||
            this.editorSelected ||
            !this.visible ||
            document.hidden ||
            this.busy
          ) return;

          this.timer = setTimeout(() => this.move(1), this.interval);
        }

        disconnectedCallback() {
          cancelAnimationFrame(this.initFrame);
          clearTimeout(this.timer);
          clearTimeout(this.animationTimer);
          this.abort?.abort();
          this.observer?.disconnect();
          this.cards?.forEach((card) => card.classList.remove('is-wrapping'));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ritual-timeline-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initRitualSlider(section) {
    if (section.dataset.rtsInitialized === 'true') return;

    var sectionId      = section.dataset.sectionId;
    var swiperEl       = section.querySelector('#rts-swiper-' + sectionId);
    var progressEl     = section.querySelector('#rts-progress-' + sectionId);
        var mobileProgressEl = section.querySelector('#rts-mobile-progress-' + sectionId);
    var timelineNodes  = section.querySelectorAll('.rts__timeline-node');
    var stepLabels     = section.querySelectorAll('.rts__step-label');
    var mobileSteps    = section.querySelectorAll('.rts__mobile-step');
    var rtsSlides      = section.querySelectorAll('.rts__slide');
    var autoplayOn     = section.dataset.autoplay === 'true';
    var autoplayDelay  = parseInt(section.dataset.autoplaySpeed, 10) || 3000;
    var transSpeed     = parseInt(section.dataset.transitionSpeed, 10) || 600;
    var total          = timelineNodes.length || section.querySelectorAll('.rts__slide').length;

    if (!swiperEl) return;

    section.dataset.rtsInitialized = 'true';

    // ── Update timeline + labels + mobile steps + active card sizing (progress bar handled separately by the autoplay engine)
    function updateUI(index) {
      // Timeline nodes
      timelineNodes.forEach(function (node, i) {
        node.classList.toggle('is-active', i === index);
      });

      // Step labels
      stepLabels.forEach(function (lbl, i) {
        lbl.classList.toggle('is-active', i === index);
      });

      // Mobile steps
      mobileSteps.forEach(function (step, i) {
        var wasActive = step.classList.contains('is-active');
        var nowActive = i === index;
        if (wasActive !== nowActive) {
          step.classList.toggle('is-active', nowActive);
          step.setAttribute('aria-expanded', nowActive ? 'true' : 'false');
        }
      });

      // Desktop slide cards: drive the "big active card" look ourselves rather
      // than relying on Swiper's own swiper-slide-active class, since with
      // slidesPerView:'auto' and few slides, Swiper considers the track
      // "locked" (nothing to scroll) and doesn't reliably reassign that
      // class when we call slideTo() programmatically.
      rtsSlides.forEach(function (slide, i) {
        slide.classList.toggle('is-current', i === index);
      });
    }

    // Swiper is already loaded globally via theme.liquid — no need to load it here.
    if (typeof Swiper === 'undefined') return;

    (function () {
      // NOTE: we intentionally never use Swiper's built-in loop or autoplay
      // modules here. Loop mode requires enough slides to clone (Swiper
      // disables it with a console warning when there aren't), and with
      // only a handful of slides + slidesPerView:'auto' they often all fit
      // in the viewport at once, meaning Swiper never considers itself to
      // have "moved" and slideChange/autoplay never fire. Driving the
      // active index ourselves with a plain interval sidesteps all of that.
      var config = {
        centeredSlides:      false,
        loop:                false,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        grabCursor:          true,
        speed:               transSpeed,
        spaceBetween:        16,
        slidesPerView:       'auto'
      };

      var swiper = new Swiper(swiperEl, config);

      // Percentage of the track each step represents (e.g. 4 steps = 33.33% per segment)
      var stepPercent     = 100 / total;
      var currentIndex    = 0;
      var autoplayTimer   = null;

     function setBarInstant(pct) {
        [progressEl && { el: progressEl, prop: 'width' }, mobileProgressEl && { el: mobileProgressEl, prop: 'height' }]
          .filter(Boolean)
          .forEach(function (bar) {
            bar.el.style.transition = 'none';
            bar.el.style[bar.prop] = pct + '%';
            // force reflow so the next transition actually applies
            void bar.el.offsetHeight;
          });
      }

      function animateBarTo(fromPct, toPct, durationMs) {
        var bars = [progressEl && { el: progressEl, prop: 'width' }, mobileProgressEl && { el: mobileProgressEl, prop: 'height' }]
          .filter(Boolean);
        if (!bars.length) return;
        setBarInstant(fromPct);
        bars.forEach(function (bar) {
          bar.el.style.transition = bar.prop + ' ' + durationMs + 'ms linear';
        });
        requestAnimationFrame(function () {
          bars.forEach(function (bar) {
            bar.el.style[bar.prop] = toPct + '%';
          });
        });
      }
      // Jump immediately to a step (manual click) — no fill animation, just snap
      function goTo(idx) {
        clearTimeout(autoplayTimer);
        currentIndex = ((idx % total) + total) % total;
        updateUI(currentIndex);
        swiper.slideTo(currentIndex);
        setBarInstant(currentIndex * stepPercent);
        startAutoplay();
      }

      // Run one autoplay segment: fill the bar over `autoplayDelay`,
      // and only flip to the next slide once the fill finishes.
      function runAutoplaySegment() {
        if (!autoplayOn || total <= 1) return;

        var nextIndex = (currentIndex + 1) % total;
        var fromPct   = currentIndex * stepPercent;
        var toPct     = (nextIndex === 0) ? 100 : nextIndex * stepPercent;

        animateBarTo(fromPct, toPct, autoplayDelay);

        autoplayTimer = setTimeout(function () {
          currentIndex = nextIndex;
          updateUI(currentIndex);
          swiper.slideTo(currentIndex);

          if (currentIndex === 0) {
            // completed a full lap — snap back to the start before the next fill begins
            setBarInstant(0);
          }
          runAutoplaySegment();
        }, autoplayDelay);
      }

      function startAutoplay() {
        if (!autoplayOn || total <= 1) return;
        stopAutoplay();
        runAutoplaySegment();
      }

      function stopAutoplay() {
        if (autoplayTimer) {
          clearTimeout(autoplayTimer);
          autoplayTimer = null;
        }
      }

      // Initialize first state immediately
      updateUI(0);
      setBarInstant(0);
      startAutoplay();

      // ── Timeline node clicks → jump straight to that slide
      timelineNodes.forEach(function (node) {
        node.addEventListener('click', function () {
          var idx = parseInt(node.dataset.slideIndex, 10);
          goTo(idx);
        });
        node.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            node.click();
          }
        });
      });

      // ── Mobile step clicks → jump straight to that slide
      mobileSteps.forEach(function (step) {
        step.addEventListener('click', function () {
          var idx = parseInt(step.dataset.index, 10);
          goTo(idx);
        });
        step.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            step.click();
          }
        });
      });

      // ── Manual swipe/drag on desktop should also sync the UI + restart autoplay
      swiper.on('slideChange', function () {
        if (swiper.activeIndex !== currentIndex) {
          goTo(swiper.activeIndex);
        }
      });
    })();
  }

  // ── Boot on DOMContentLoaded or Shopify section:load
  function boot() {
    document.querySelectorAll('[data-section-id]').forEach(function (section) {
      if (section.classList.contains('rts')) {
        initRitualSlider(section);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify Theme Editor live reload
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.rts');
    if (section) initRitualSlider(section);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-marquee"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /**
   * Trust Marquee – ensures the track is wide enough for a seamless
   * infinite loop regardless of viewport width. If the two pre-rendered
   * copies do not fill the viewport × 2, additional clones are inserted.
   */
  function initMarquee(section) {
    var wrap  = section.querySelector('.trust-marquee__track-wrap');
    var track = section.querySelector('.trust-marquee__track');
    if (!wrap || !track) return;

    var lists = track.querySelectorAll('.trust-marquee__list');
    if (!lists.length) return;

    // Wait until fonts/images are ready to get accurate widths
    function setup() {
      var viewportW   = wrap.offsetWidth;
      var setW        = 0;

      // Measure ONE full set (first list rendered)
      setW = lists[0].offsetWidth + 12; // 12 = gap approximation

      if (setW === 0) return; // layout not ready yet

      // We need at least (viewportW × 2) worth of content so the
      // animation never reveals empty space.
      var setsNeeded = Math.ceil((viewportW * 2) / setW) + 1;
      var currentSets = lists.length / 1; // already have 2 from Liquid

      if (currentSets < setsNeeded) {
        var frag = document.createDocumentFragment();
        for (var i = currentSets; i < setsNeeded; i++) {
          frag.appendChild(lists[0].cloneNode(true));
        }
        track.appendChild(frag);
      }

      // Recalculate total track width for animation
      // The CSS animation moves by -50% when there are 2 equal sets.
      // If we added more, we need to adjust.
      var totalLists  = track.querySelectorAll('.trust-marquee__list').length;
      var singleSetPx = setW * (totalLists / 2); // rough
      // Rewrite as pixel-based if sets != 2
      if (totalLists !== 2) {
        var onePx = track.scrollWidth / totalLists;
        var pct   = ((onePx * Math.floor(totalLists / 2)) / track.scrollWidth) * 100;
        track.style.setProperty('--tm-to-x', '-' + pct.toFixed(4) + '%');

        // If custom property not handled by existing keyframe, inject inline style
        // (fallback: override animation with a dynamically created class)
        var styleId = 'tm-dyn-' + section.id;
        var existing = document.getElementById(styleId);
        if (!existing) {
          var s = document.createElement('style');
          s.id  = styleId;
          s.textContent =
            '@keyframes trust-marquee-scroll-' + section.id + ' {' +
              'from { transform: translate3d(0,0,0); }' +
              'to   { transform: translate3d(' + (-pct).toFixed(4) + '%, 0, 0); }' +
            '}';
          document.head.appendChild(s);
          track.style.animationName = 'trust-marquee-scroll-' + section.id;
        }
      }
    }

    // Run after paint
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(setup);
    } else {
      setTimeout(setup, 100);
    }

    // Re-run on resize (debounced)
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(setup, 200);
    }, { passive: true });
  }

  // ── Boot ──────────────────────────────────────────────────
  function boot() {
    document.querySelectorAll('.trust-marquee').forEach(initMarquee);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify Theme Editor live-reload
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('.trust-marquee');
      if (section) initMarquee(section);
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
